// ---------------------------------------------
// Facets z-index - DeSight Shopify Theme
// ---------------------------------------------
// Versteckt .dss-floating-contact und cookie-widget-wrapper wenn:
//  - Facet-Filter geöffnet sind
//  - Mobile Menu Drawer geöffnet ist (.menu-opening auf body)
// ---------------------------------------------

import { $ } from '../utils/helpers.js';

let floatingContact = null;
let cookieWidget = null;
let observer = null;

function isFacetDetails(el) {
  return (
    el.tagName === 'DETAILS'
    && (
      el.classList.contains('js-filter')
      || el.classList.contains('mobile-facets__disclosure')
      || el.classList.contains('facets__disclosure')
      || el.classList.contains('facets__disclosure-vertical')
      || el.classList.contains('dss-facets__details')
    )
  );
}

function anyFacetOpen() {
  const details = document.querySelectorAll('details.js-filter, details.mobile-facets__disclosure');
  for (const d of details) {
    if (d.hasAttribute('open')) return true;
  }
  return false;
}

function isMenuOpen() {
  const menuDetails = document.getElementById('Details-menu-drawer-container');
  return menuDetails && menuDetails.hasAttribute('open');
}

function setHidden(el) {
  if (!el) return;
  el.style.setProperty('z-index', '-1', 'important');
  el.style.setProperty('visibility', 'hidden', 'important');
}

function setVisible(el, z) {
  if (!el) return;
  el.style.setProperty('z-index', String(z), 'important');
  el.style.setProperty('visibility', 'visible', 'important');
}

function hideCookieWidget() {
  cookieWidget = cookieWidget || document.querySelector('cookie-widget-wrapper');
  setHidden(cookieWidget);
}

function showCookieWidget() {
  cookieWidget = cookieWidget || document.querySelector('cookie-widget-wrapper');
  setVisible(cookieWidget, 250);
}

function startCookieWidgetObserver() {
  if (cookieWidget) return; // already found

  const cookieObserver = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (node.nodeType === 1 && (node.tagName === 'COOKIE-WIDGET-WRAPPER' || node.matches?.('cookie-widget-wrapper'))) {
          cookieWidget = node;
          cookieObserver.disconnect();
          // Apply current state
          if (anyFacetOpen() || isMenuOpen()) {
            setHidden(cookieWidget);
          }
          return;
        }
      }
    }
  });

  cookieObserver.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
}

function hideFloatingElements() {
  setHidden(floatingContact);
  hideCookieWidget();
}

function showFloatingElements() {
  setVisible(floatingContact, 250);
  showCookieWidget();
}

function updateZIndex() {
  if (anyFacetOpen() || isMenuOpen()) {
    hideFloatingElements();
  } else {
    showFloatingElements();
  }
}

function onMenuToggle() {
  // Small delay: body.classList is updated synchronously by Dawn
  updateZIndex();
}

function startMenuDrawerListener() {
  const menuDrawerDetails = document.getElementById('Details-menu-drawer-container');
  if (menuDrawerDetails) {
    menuDrawerDetails.addEventListener('toggle', onMenuToggle);
  }
}

function startObserver() {
  if (observer) observer.disconnect();

  const handleMutation = () => {
    if (anyFacetOpen() || isMenuOpen()) {
      hideFloatingElements();
    } else {
      showFloatingElements();
    }
  };

  observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (m.type === 'attributes' && m.attributeName === 'open') {
        if (isFacetDetails(m.target)) {
          handleMutation();
          return;
        }
      }
      if (m.type === 'attributes' && m.attributeName === 'class') {
        if (m.target === document.body) {
          handleMutation();
          return;
        }
      }
      if (m.type === 'childList') {
        for (const node of m.addedNodes) {
          if (node.nodeType === 1 && isFacetDetails(node)) {
            handleMutation();
            return;
          }
          if (node.nodeType === 1) {
            const inner = node.querySelectorAll?.('details.js-filter, details.mobile-facets__disclosure');
            if (inner.length > 0) {
              handleMutation();
              return;
            }
          }
        }
      }
    }
  });

  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['open', 'class'],
    childList: true,
    subtree: true
  });
}

export function initFacetsZindex() {
  floatingContact = $('.dss-floating-contact');
  cookieWidget = document.querySelector('cookie-widget-wrapper');
  if (!floatingContact && !cookieWidget) {
    startCookieWidgetObserver();
    return;
  }

  updateZIndex();
  startMenuDrawerListener();
  startObserver();
  if (!cookieWidget) startCookieWidgetObserver();
}

document.addEventListener('shopify:section:load', () => {
  initFacetsZindex();
});
